import { useQuery } from "@tanstack/react-query";
import MetadataService from "../../common/services/MetadataService";
import { getActivityIntervalOptions, getDepartmentOptions, getDivisionOptions, getDomainOptions, getEmploymentTypeOptions, getVocationalActivitiesOptions } from "../api/options";

const meta = new MetadataService();

export const useDomainOptionsQuery = () => {
  return useQuery({
    queryKey: ["domainOptions"],
    queryFn: () => getDomainOptions(),
  })
}

export const useDivisionOptionsQuery = () => {
  return useQuery({
    queryKey: ["divisionOptions"],
    queryFn: () => getDivisionOptions(),
  })
}

export const useVocationalActivitiesOptionsQuery = () => {
  return useQuery({
    queryKey: ["vocationalActivitiesOptions"],
    queryFn: () => getVocationalActivitiesOptions(),
  })
}

export const useDepartmentOptionsQuery = () => {
  return useQuery({
    queryKey: ["departmentOptions"],
    queryFn: () => getDepartmentOptions(),
  })
}

export const useActivityIntervalOptionsQuery = () => {
  return useQuery({
    queryKey: ["activityIntervalOptions"],
    queryFn: () => getActivityIntervalOptions(),
  })
}

export const useEmploymentTypeOptionsQuery = () => {
  return useQuery({
    queryKey: ["employmentTypeOptions"],
    queryFn: () => getEmploymentTypeOptions(),
  })
}

export const useProgramFieldsOptionsQuery = () => {
  return useQuery({
    queryKey: ["programFieldsOptions"],
    queryFn: () => {      
      const getFields = meta.get('programs');
      return getFields.program_type.options;
    },
  })
}